import React, { Component } from "react";

class ExpertUploadComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedFiles: []
        }
    }

    onChangeHandler = event => {
        const selectedFiles = event.target.files;
        const acceptedExtensions = Array.isArray(this.props.acceptedExtensions)
            ? this.props.acceptedExtensions.map(extension => (extension || "").toString().trim().toLowerCase().replace(/^\./, "")).filter(Boolean)
            : [];

        if (acceptedExtensions.length) {
            const acceptedExtensionsSet = new Set(acceptedExtensions);
            const invalidFiles = Array.from(selectedFiles || []).filter(file => {
                const fileName = file && file.name ? file.name : "";
                const extension = fileName.includes(".") ? fileName.split(".").pop().toLowerCase() : "";
                return !acceptedExtensionsSet.has(extension);
            });

            if (invalidFiles.length) {
                if (typeof this.props.onValidationError === "function") {
                    this.props.onValidationError({
                        invalidFiles,
                        acceptedExtensions
                    });
                }
                event.target.value = "";
                this.setState({
                    selectedFiles: []
                }, () => this.props.onSelectedFiles([]));
                return;
            }
        }

        this.setState({
            selectedFiles: selectedFiles,
        }, () => this.props.onSelectedFiles(this.state.selectedFiles))
    }

    render() {
        const acceptedExtensions = Array.isArray(this.props.acceptedExtensions)
            ? this.props.acceptedExtensions.map(extension => (extension || "").toString().trim().toLowerCase().replace(/^\./, "")).filter(Boolean)
            : [];
        const acceptValue = acceptedExtensions.length ? acceptedExtensions.map(extension => `.${extension}`).join(",") : undefined;

        return (
            <div className="custom-file" style={this.props.style || {}}>
                <input type="file" multiple className="custom-file-input" onChange={this.onChangeHandler} id="customFile" accept={acceptValue} disabled={this.props.isDisabled} />
                <label className="custom-file-label" htmlFor="customFile">{this.state.selectedFiles.length ? "Pliki do przesłania: " + this.state.selectedFiles.length : "Wybierz pliki"}</label>
            </div>
        )
    }

}

export default ExpertUploadComponent;